"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaneIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M8.63262 15.269L8.56151 15.137L8.42944 15.0659L2.92466 12.1017C1.81414 11.5038 1.89258 9.88552 3.05572 9.39775L20.1915 2.21178C20.562 2.0564 20.9897 2.1405 21.2739 2.42462C21.558 2.70874 21.6421 3.13646 21.4867 3.50701L14.3007 20.6428C13.813 21.8059 12.1947 21.8843 11.5967 20.7738L8.63262 15.269Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M11.2901 20.7131L11.1834 20.515L10.9853 20.4084L2.94128 16.077C2.01584 15.5787 2.08121 14.2301 3.05049 13.8236L25.9867 4.20523C26.4177 4.02449 26.9152 4.12232 27.2457 4.4528C27.5761 4.78328 27.674 5.28079 27.4932 5.71179L17.8748 28.648C17.4684 29.6173 16.1198 29.6826 15.6215 28.7572L11.2901 20.7131Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0) }), void 0));
};
var PlaneIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.PlaneIcon = PlaneIcon;
//# sourceMappingURL=PlaneIcon.js.map